import React from 'react';
import "../css/contact.css";
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { connect } from 'react-redux';

const Contactus = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <div className='about-container'>
        <div className='about-left'>
          <div className='breadcrum'>
            <div className='heading-wrapper'>
              <h1 className='about-heading'>
                <strong>{data.contactus_heading}</strong> <span>{data.contactus_subheading}</span>
                <span className='about-heading-bg'>{data.contactus_heading} {data.contactus_subheading}</span>
              </h1>
            </div>
            <Link className='home-link' to="/">{data.home}</Link>
            <span className='seperator'>|</span>
            <span className='aboutus-link'>{data.contactus_heading} {data.contactus_subheading}</span>
          </div>
        </div>

        <div className='about-right'>
          <img
            src={data.banner_image}
            alt="team working"
            className='about-image'
            width="300px"
            height="300px"
          />
        </div>
      </div>

      <div className="contact-container">
        <div className="contact-left">
          <h1 className="contact-title">{data.heading}</h1>
          <p className="contact-description">{data.subheading}</p>
        </div>

        <div className="contact-right">
          <div className="contact-card">
            <FaMapMarkerAlt className="contact-iconone" />
            <div>
              <h3>{data.office_heading}</h3>
              <p>{data.office_address}</p>
            </div>
          </div>
          <div className="contact-card">
            <FaPhoneAlt className="contact-icon" />
            <div>
              <h3>{data.phone_heading}</h3>
              <p>{data.phone_number}</p>
            </div>
          </div>
          <div className="contact-card">
            <FaEnvelope className="contact-icon" />
            <div>
              <h3>{data.email_heading}</h3>
              <p>{data.email_addresses}</p>
              <p>{data.secondary_email}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.contactus.data,
});

export default connect(mapStateToProps)(Contactus);
